module.exports = __webpack_public_path__ + "static/media/fai_illustration.5d1d3ebd.jpg";